import { createSlice } from '@reduxjs/toolkit';

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    open: false,
    menus: null,
  },
  reducers: {
    setMenuOpen: (state, action) => {
      state.open = action.payload;
    },
    setMenus: (state, action) => {
      state.menus = action.payload;
    },
  },
});

export const { setMenuOpen, setMenus } = sidebarSlice.actions;

export default sidebarSlice.reducer;
